// src/components/Footer.jsx
import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-container" role="contentinfo">
      <div className="footer-content">
        <img
          src="/logo-leafloop_256x256_no_background.png" // Assumes logo.png in public/
          alt="MendGrove Logo"
          className="footer-logo"
          onError={(e) => {
            e.target.src = "/fallback_logo.png"; // Fallback image
            e.target.alt = "MendGrove Fallback Logo";
          }}
        />
        <p className="footer-text">© MendGrove {new Date().getFullYear()}</p>
        <span className="footer-separator" aria-hidden="true">·</span>
        <a href="/provider/signin" className="footer-link">
          For healthcare providers
        </a>
      </div>
    </footer>
  );
};

export default Footer;
